import { Routes } from '@angular/router';

export const llmSettingsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./llm-settings.component').then((m) => m.LlmSettingsComponent),
  },
];
